import React, {useEffect, useRef} from "react";
import gsap from "gsap";

import styles from "./Editeurs.module.scss";
import Image from "./Global/Image";
import TitleBloc from "./Elements/TitleBloc";

import backgroundSrc from "../images/background-03.jpg";
import backgroundSrcRet from "../images/background-03@2x.jpg";
import backgroundWebp from "../images/background-03.webp";
import backgroundWebpRet from "../images/background-03.webp";
import backgroundMobile from "../images/mobile/background-03.webp";

import src from "../images/editeurs-01.jpg";
import srcRet from "../images/editeurs-01@2x.jpg";
import webp from "../images/editeurs-01.webp";
import webpRet from "../images/editeurs-01@2x.webp";
import Plus from "./Pictos/Plus";
import ImageText from "./Elements/ImageText";
import isMobile from "ismobilejs";

export default function Editeurs() {
    const masthead = useRef(null);

    useEffect(() => {
        const acteurs = document.getElementsByClassName(styles.Acteurs)[0];
        const details = acteurs.querySelectorAll('details');

        Object.values(details).map(detail =>
            detail.addEventListener('click', () => {
                if (getComputedStyle(masthead.current).position === 'sticky') {
                    setTimeout(() => {
                        const topValue = parseFloat(getComputedStyle(masthead.current).top.replace('px', ''));
                        const detailHeight = detail.querySelector('.accordion--text').getBoundingClientRect().height + 40
                        if (detail.getAttribute('open')) {

                            gsap.to(masthead.current, .5, {
                                top: topValue + detailHeight
                            })
                        } else {
                            gsap.to(masthead.current, .5, {
                                top: topValue - detailHeight
                            })
                        }
                    }, 200)
                }
            })
        );
    }, []);

    return (
        <section className={styles.Main}>
            <div className={'container'} ref={masthead}>
                <ImageText rtl={true} image={{src, srcRet, webp, webpRet}} classname={'sticky--image'}>
                    <div className={styles.MastheadText}>
                        <p>
                            Chez les éditeurs, l'offre est nettement plus diverse même si plusieurs mastodontes se
                            dégagent. Les Américains tiennent le haut du pavé avec le leader Electronic Arts, mais aussi
                            l’ancien numéro 1 Activision Blizzard. Parmi les challengers, on retrouve notamment Take-Two
                            Interactive (Grand Theft Auto), Epic Games, Warner Bros Interactive… Tencent, le conglomérat
                            chinois qui est un acteur global du numérique, a investi massivement ces dernières années
                            dans les jeux vidéo : 100% de Riot Games (League of Legends, Valorant), 40% d’Epic Games
                            (Fortnite), 80% de Supercell (Clash Royale, Clash of Clans)….
                        </p>
                        {
                            isMobile().phone ? <div data-image-mobile/> : null
                        }
                        <p>
                            En France, Ubisoft (Assassin’s Creed, Just Dance, Rayman, Watch Dogs, Far Cry), Gameloft
                            (jeux mobiles) ou d’autres acteurs comme Focus Home Interactive ont réussi à se faire une
                            place sur l’échiquier mondial. Embracer Group, Square Enix, Capcom, Bandai Namco sont aussi
                            des acteurs de poids…
                        </p>

                        <div className={styles.Acteurs}>
                            <h3 className={styles.ActeursTitle}>
                                Les principaux <strong>acteurs du marché</strong>
                            </h3>

                            <ul className={'accordion'}>
                                <li>
                                    <details>
                                        <summary>
                                            <p>
                                                <strong>Fabricant de consoles</strong>
                                                <Plus/>
                                            </p>
                                        </summary>
                                        <p className={'accordion--text'}>
                                            Sony (PlayStation), Microsoft (Xbox) et Nintendo (Wii, Switch…).
                                        </p>
                                    </details>
                                </li>

                                <li>
                                    <details>
                                        <summary>
                                            <p>
                                                <strong>Plateformes</strong>
                                                <Plus/>
                                            </p>
                                        </summary>
                                        <p className={'accordion--text'}>
                                            Steam, Twitch (Amazon).
                                        </p>
                                    </details>
                                </li>

                                <li>
                                    <details>
                                        <summary>
                                            <p>
                                                <strong>Jeux mobile (smartphone et tablette)</strong>
                                                <Plus/>
                                            </p>
                                        </summary>
                                        <p className={'accordion--text'}>
                                            Tencent (PUBG, Honor of Kings, Clash of clans), Gameloft (Asphalt, Dungeon
                                            Hunter),
                                            King (Candy Crush, Farm Heroes, Bubble Witch), Voodoo (Paper.io), Zynga.
                                        </p>
                                    </details>
                                </li>

                                <li>
                                    <details>
                                        <summary>
                                            <p>
                                                <strong>Editeurs</strong>
                                                <Plus/>
                                            </p>
                                        </summary>
                                        <p className={'accordion--text'}>
                                            Activision Blizzard (Call of Duty, Crash Bandicoot, Tony Hawk’s), Electronic
                                            Arts
                                            (Battlefield, Fifa, Les Sims, Apex Legends, Mass Effect), Ubisoft
                                            (Assassin’s Creed,
                                            Just Dance, Rayman, Watch Dogs, Far Cry), Microsoft (Age of Empire, Flight
                                            Simulator),
                                            Take-Two (Grand Theft Auto, Red Dead, Bioshock, Mafia…), Capcom (Street
                                            Fighter,
                                            Resident Evil), Square Enix (Final Fantasy, Kingdom Hearts), Warner Bros
                                            interactive
                                            (Mortal Kombat, Batman, Lego), Focus Home Interactive (The Surge, Farming
                                            Simulator),
                                            Bandai Namco (Tekken, SoulCalibur, Tales of Symphonia).
                                        </p>
                                    </details>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ImageText>
            </div>

            <TitleBloc number={3} image={{
                src: backgroundSrc,
                srcRet: backgroundSrcRet,
                webp: backgroundWebp,
                webpRet: backgroundWebpRet,
                mobile: backgroundMobile
            }}>
                <h2>
                    Un marché « boosté » <br/>
                    par la pandémie mondiale
                </h2>

                <p>
                    Si certains aspects de l’industrie du divertissement ont énormément souffert de la crise sanitaire,
                    des concerts ayant été annulés et les cinémas et théâtres ayant fermé leurs portes, le jeu vidéo a
                    de son côté prospéré. Alors que la pandémie de Covid-19 continue à se propager à travers le monde,
                    des milliards de personnes se sont retrouvées confinées chez elles l’an dernier. Et nombre d'entre
                    elles se sont tournées vers les jeux vidéo pour passer le temps, entraînant une forte hausse des
                    ventes dans l'industrie.
                </p>
            </TitleBloc>
        </section>
    )
}
